export default __webpack_public_path__ + "static/media/customer-support.3d21b7da.png";